/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody, Table, Progress } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import ProviderService from '../../../services/ProviderService';

// local imports
import ErrorBoundary from '../../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import Loading from '../../../assets/UW_Horizontal_Logo_Full.png';
import Arrow from '../../../assets/arrow.svg';
import FindProviderImg from '../../../assets/active_support.svg';
import UserNotApproved from './UserNotApproved';
import { providerSubscriptionPlans, providerSubscriptions as dbProviderSubscriptions } from '../demoData';

const UpdateProviderSubscription = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states
    const [availablePlans, setAvailablePlans] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [currentPlan, setCurrentPlan] = useState({ serviceDetails: { modeOfServices: {} } });
    const [currentSubscription, setCurrentSubscription] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // useEffects
    useEffect(() => {
        setIsLoading(true);
        const tempCurrentPlan = dbProviderSubscriptions[0].providerSubscriptionPlan;
        setCurrentSubscription(dbProviderSubscriptions[0]);
        setCurrentPlan(dbProviderSubscriptions[0].providerSubscriptionPlan);
        setAvailablePlans(providerSubscriptionPlans);
        setIsLoading(false);
    }, []);

    // handle functions
    const handlePlanSelect = e => {
        if (selectedPlan._id) {
            try {
                props.history.push({
                    pathname: "/demo/counsellor/makesubscriptionpayment",
                    state: {
                        isUpdate: true,
                        selectedSubscriptionPlan: selectedPlan,
                        oldPlan: currentSubscription
                    }
                });
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {

                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        }
    }

    // function's return
    return (
        <div>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus || true ?
                        <div className="p-2">
                            <div>
                                <div className="text-center">
                                    <h1 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Change Subscription Plan</h1>
                                    <h2 style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Your existing plan will be cancelled.<br />Refund will be processed for days left in your existing plan within 7 business days.</h2>
                                </div>
                                <div className="row pt-4">
                                    <div className="col-12 col-md-3 text-center">
                                        <div className="newPlanListTitleDiv">
                                            <h2 style={{ color: "#384E73", fontFamily: "Montserrat, sans-serif", fontSize: "1.4rem", fontWeight: "500" }}>Current Subscription</h2>
                                        </div>
                                        <div className="px-2 py-3 mx-md-0 mx-2" style={theme.disabledSlotCard}>
                                            <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{currentPlan.name}</h2>
                                            <p>{`₹${currentPlan.amount / 100} / Month`}</p>
                                            <div>
                                                <p><i className='fas fa-check'></i> Upto {currentPlan.serviceDetails.sessionBookingLimit} Session Bookings</p>
                                                <p><i className='fas fa-check'></i> Upto {currentPlan.serviceDetails.clientLimit} Clients</p>
                                                <p><i className={`fas fa-${currentPlan.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i> Call</p>
                                                <p><i className={`fas fa-${currentPlan.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i> Chat</p>
                                                <p><i className={`fas fa-${currentPlan.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i> Video</p>
                                                <p><i className={`fas fa-${currentPlan.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i> In Person</p>
                                                <p><i className={`fas fa-${currentPlan.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i> Create Client Subscription Plans</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="planUpdateArrow" className="col-3 col-md-2 mx-auto"></div>
                                    <div className="col-12 col-md-7 text-center">
                                        <div className="newPlanListTitleDiv">
                                            <h2 style={{ color: "#384E73", fontFamily: "Montserrat, sans-serif", fontSize: "1.4rem", fontWeight: "500" }}>Update To</h2>
                                        </div>
                                        <div className="newPlanList row justify-content-between mx-0">
                                            {
                                                availablePlans.map((item, index) => (
                                                    item.razorpaySubscriptionPlanId === currentSubscription.providerSubscriptionPlan.razorpaySubscriptionPlanId ? null :
                                                        <div key={index} className="col-md-5 col-11 text-center px-2 py-3 mb-3 mt-md-0 mt-1 mx-md-0 mx-2" style={selectedPlan._id == item._id ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedPlan(item)}>
                                                            <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                                            <p>{`₹${item.amount / 100} / Month`}</p>
                                                            <div>
                                                                <p><i className='fas fa-check'></i> Upto {item.serviceDetails.sessionBookingLimit} Session Bookings</p>
                                                                <p><i className='fas fa-check'></i> Upto {item.serviceDetails.clientLimit} Clients</p>
                                                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.call ? 'check' : 'times danger_text_color'}`}></i> Call</p>
                                                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.chat ? 'check' : 'times danger_text_color'}`}></i> Chat</p>
                                                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.video ? 'check' : 'times danger_text_color'}`}></i> Video</p>
                                                                <p><i className={`fas fa-${item.serviceDetails.modeOfServices.inPerson ? 'check' : 'times danger_text_color'}`}></i> In Person</p>
                                                                <p><i className={`fas fa-${item.serviceDetails.createClientSubscriptionPlans ? 'check' : 'times danger_text_color'}`}></i> Create Client Subscription Plans</p>
                                                            </div>
                                                        </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.button} onClick={() => handlePlanSelect()}>
                                        Continue Payment
                                    </button>
                                </div>
                            </div>
                        </div >
                        :
                        <UserNotApproved />
            }
        </div >
    )

}

export default UpdateProviderSubscription;